import { UserDto } from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const avonPatientRequests = {
  getMemberIdFromAvonPatientId: EndpointDefinition.get<
    { member: UserDto },
    { avonPatientId: string }
  >({
    name: 'getMemberIdFromAvonPatientId',
    route: '/avon/patients/get-reema-id',
  }),
  createAvonPatient: EndpointDefinition.post<
    { memberId: UserDto },
    { memberId: string },
    {}
  >({
    name: 'createAvonPatient',
    route: '/avon/patients/add-patient',
  }),
};
